import React from "react";
import {Badge, Button, Grid, GridItem, List, ListItem, Modal, ModalVariant} from "@patternfly/react-core";
import {IoClose} from "react-icons/io5";
import {GalleryItemData} from "../../Context/ItemsProvider/ItemsProviderDomain";
import {useItemsDispatcherState} from "../../Context/ItemsProvider/ItemsProvider";
import {getFiles} from "../../Context/ItemsProvider/ItemsProviderActions";
import {useAuthState} from "../../Context/AuthProvider/AuthProvider";

interface ViewProps{
    isModalOpen: boolean;
    setIsModalOpen: (boolean)=>void;
    items: GalleryItemData[]
    selectedIds: string[]
    onClickItem: ( newId:string) => void;
}

export const DiazarModalDownloads: React.FunctionComponent<ViewProps> = (props) => {
    const userDetails = useAuthState()
    const itemsDispatcher = useItemsDispatcherState()

    const handleModalToggle = React.useCallback( ()=>{
        props.setIsModalOpen( prev => !prev )
    }, [props])

    const selectedItems = React.useMemo<GalleryItemData[]>( ()=>{
        return props.items.filter( data => props.selectedIds.includes( data.id ) )
    }, [props.items, props.selectedIds] )

    const getItemsFile = React.useCallback( async ()=>{
        const token = (userDetails.token) ? userDetails.token : ''

        getFiles( token, props.selectedIds, itemsDispatcher ).then(  )
        props.setIsModalOpen( false )
    }, [ itemsDispatcher, userDetails.token, props ] )

    React.useEffect( ()=>{
        if( selectedItems.length === 0 ){
            props.setIsModalOpen(false)
        }
    }, [selectedItems.length, props] )

    return (
        <React.Fragment>
            <Modal
                variant={ModalVariant.large}
                title="Archivos a descargar"
                isOpen={ props.isModalOpen }
                onClose={handleModalToggle}
                actions={[
                    <Button key="confirm" variant="primary" onClick={getItemsFile}>
                        Confirmar
                    </Button>,
                    <Button key="cancel" variant="danger" onClick={handleModalToggle}>
                        Cancelar
                    </Button>
                ]}
            >
                <List isPlain isBordered>
                { selectedItems.map( data => (
                    <ListItem key={data.id}>
                        <Grid>
                            <GridItem sm={4}>
                                <IoClose onClick={ () => { props.onClickItem( data.id ) } } /> {data.name}
                            </GridItem>
                            <GridItem sm={5}> {data.file_description} </GridItem>
                            <GridItem sm={3}>
                                <Badge isRead>{data.human_type}</Badge>{ ' ' }
                                <Badge isRead>{data.human_size}</Badge>{ ' ' }
                            </GridItem>
                        </Grid>
                    </ListItem>
                ) ) }
                </List>
            </Modal>
        </React.Fragment>
    )
}